module.exports = __webpack_public_path__ + "img/03.b8409502.png";